export default __webpack_public_path__ + "static/media/section.71387ba8.png";